import React, {Component} from "react";
import {Breadcrumb, Layout, Menu} from "antd";
import AppService from "./app.service";
import AppModel from "../models/app";
import FunctionItem from "../models/functionItem";
import CommonTree from "../models/commonTree";
import {RouteComponentProps} from "react-router";
import UIHeader from "./head";
import AppContext from "./app-context";
import "../../style/index.css";
import "../../assets/style/basic.css";
import "../../assets/style/commonUse.css";
import {EventBus} from "marmot_design_ui";
import {validate} from "./app.api";
import Cookies from "js-cookie";
import showMemu from '../../assets/images/showMemu.svg'
import hiddenMenu from '../../assets/images/hiddenMenu.svg'


import {findAncestors, findFunctionIdByUrl, findSubFunctionItem, findUrlInMenu, isInBxApp} from "../utils";

const {SubMenu} = Menu;
const {Content, Sider, Footer} = Layout;

interface iProps extends RouteComponentProps {
    children: React.ReactNode;
    appName: string;
    appModel?: AppModel;
    leftMenuApi?: string;
    topBarUrl?: string;
    hiddenLeftMenu?: boolean;
    enumUrl?: string;
    showHeader?: boolean;
    onMenuClick?: () => void;
    breadCrumb?: boolean
    defaultUrl?: string
    defaultDes?: string;
}

interface iState {
    app: AppModel;
    showMenu: boolean;
    initialized: boolean;
    defaultOpenKeys: string[];
    zoneList: CommonTree[];
    breadcrumbItem: string[];
    selectedKeys: string[];
    render: boolean;
}

export default class App extends Component<iProps, iState> {
    private unlisten: (() => void) | null = null;
    private appService: AppService = new AppService();
    private isInternalNavigation: boolean = false;  // **标记是否是内部跳转**
    state: iState = {
        app: new AppModel(),
        showMenu: false,
        initialized: false,
        zoneList: [],
        breadcrumbItem: [],
        selectedKeys: [],
        defaultOpenKeys: [],
        render: false
    };

    goToDefaultUrl = () => {
        const {app} = this.state;
        const functionItems = app.functionItems ?? [];
        const firstItem = functionItems?.[0];

        if (!firstItem) {
            console.warn("No function items available.");
            return;
        }

        const url = firstItem.subFunctionItems?.[0]?.url || firstItem.url;
        if (!url) {
            console.warn("No URL found for the first function item.");
            return;
        }
        const paths = this.findPathByKey(url);
        this.isInternalNavigation = true; // **标记为内部跳转**
        this.props.history.replace({pathname: url});
        this.setState({
            selectedKeys: [url],
            defaultOpenKeys: [firstItem.functionId],
            breadcrumbItem: [this.state.breadcrumbItem[0], ...paths].filter(Boolean),
        });
    };
    /** 计算当前 URL 对应的选中菜单项 */
    updateMenuSelection = (location) => {

        if (this.isInternalNavigation) {
            this.isInternalNavigation = false; // **如果是内部跳转，则跳过处理**
            return;
        }
        const {app} = this.state;

        const functionItems = app?.functionItems || [];
        if (location.pathname === "/") {
            this.goToDefaultUrl();
            return;
        }

        const findFunctionId = findFunctionIdByUrl(functionItems, location.pathname);
        if (findFunctionId) {
            const openKey = findAncestors(functionItems, findFunctionId);
            const paths = this.findPathByKey(location.pathname);
            this.setState({
                selectedKeys: [location.pathname],
                defaultOpenKeys: openKey || [],
                breadcrumbItem: [this.state.breadcrumbItem[0], ...paths].filter(Boolean),
            });
            // **🚀 避免无限循环**
            if (this.props.location.pathname !== location.pathname) {
                this.isInternalNavigation = true;
                this.props.history.replace(location);
            }
            return;
        }
        const {url, functionId} = findSubFunctionItem(functionItems, location.pathname);
        if (url && functionId) {
            const paths = this.findPathByKey(url);
            const openKey = findAncestors(functionItems, functionId);
            this.setState({
                selectedKeys: [url],
                defaultOpenKeys: openKey || [],
                breadcrumbItem: [this.state.breadcrumbItem[0], ...paths].filter(Boolean),
            });
            // **🚀 避免无限循环**
            if (this.props.location.pathname !== url) {
                this.isInternalNavigation = true;
                this.props.history.replace({
                    ...location,
                    pathname: url
                });
            }
            return;
        }

        if (!(document.getElementById('galaxy-component-framework')?.children?.length > 0)) {
            this.goToDefaultUrl()
        }
    };
    listenToRouteChanges = () => {
        if (this.unlisten) {
            this.unlisten();
        }
        this.unlisten = this.props.history.listen((location, action) => {
            console.log("📌 监听到路由变化:", location.pathname, "动作:", action, "isInternalNavigation:", this.isInternalNavigation);

            if (this.isInternalNavigation) {
                console.log("🚀 内部跳转，跳过 updateMenuSelection()");
                this.isInternalNavigation = false;
                return;
            }

            this.updateMenuSelection(location);
        });
    };

    async componentDidMount() {
        await this.validate();
        await this.getAppInfo()
        this.setState({initialized: true});
        this.updateMenuSelection(this.props.location);
        this.listenToRouteChanges();
        // 监听事件：reloadAppInfo
        EventBus.on('reloadAppInfo', this.reloadAppInfo);
    }

    /** 取消监听 */
    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
        // 移除事件监听
        EventBus.off('reloadAppInfo', this.reloadAppInfo);
    }

    async validate() {

        let {data} = await validate(Cookies.get("token"));
        if (data == "ok") {
            (document.querySelector("#root") as HTMLDivElement).style.display =
                "block";
            (document.querySelector("#splash") as HTMLDivElement).style.display =
                "none";
        } else {
            window.location.replace(
                `/fe-pc/fe_newlogin/login?fromUrl=${window.location.href}`
            );
        }
    }

    async getAppInfo() {
        this.setState({
            render: false
        })
        try {
            let {
                appName,
                leftMenuApi,
                topBarUrl,
                appModel = null,
                enumUrl,
                showHeader
            } = this.props;
            let app: AppModel;
            if (!appModel) {
                app = await this.appService.getAppInfo({
                    appName,
                    leftMenuApi,
                    topBarUrl,
                    enumUrl,
                    showHeader
                });
                const filtered = (app?.menuItems ?? []).filter(
                    (item) => !['-1', '-2'].includes(item.menuId)
                )
                const BxAppNavigations = filtered.reduce((acc, item) => {
                    if ((item.subMenus?.length ?? 0) > 0) {
                        return acc.concat(item.subMenus);
                    } else {
                        return acc.concat([item]);
                    }
                }, []);


                if (BxAppNavigations.length <= 1) {
                    isInBxApp && window.BXBridge?.hideNavigationBar()
                } else {
                    isInBxApp && window.BXBridge?.showNavigationBar(JSON.stringify(BxAppNavigations))
                }

            } else app = appModel;
            let breadcrumbItem: string[] = [];
            const matchedMenu = app.menuItems.find(menuItem =>
                menuItem?.appName === this.props.appName
            );
            if (matchedMenu) {
                breadcrumbItem = [matchedMenu.name];
            } else {
                const parentMenu = app.menuItems.find(menuItem =>
                    menuItem?.subMenus?.some(subMenu => subMenu?.appName === this.props.appName)
                );
                const matchedSubMenu = parentMenu?.subMenus?.find(subMenu => subMenu?.appName === this.props.appName);
                if (parentMenu && matchedSubMenu) {
                    breadcrumbItem = [matchedSubMenu.name];
                }
            }
            this.setState({
                breadcrumbItem,
                render: true,
                app: {
                    ...app,
                    functionItems: app?.functionItems?.map(e => {
                        return {
                            ...e,
                            functionId: e.functionId + e.url,
                            subFunctionItems: e.subFunctionItems?.map(e => {
                                return {
                                    ...e,
                                    functionId: e.functionId + e.url
                                }
                            })
                        }
                    })
                }
            });

        } catch (e) {
            this.setState({
                render: true
            })
        }
    }

    reloadAppInfo = async () => {
        this.setState({
            render: false
        })
        try {
            let {
                appName,
                leftMenuApi,
                topBarUrl,
                appModel = null,
                enumUrl,
                showHeader
            } = this.props;
            let app: AppModel;
            if (!appModel) {
                app = await this.appService.getAppInfo({
                    appName,
                    leftMenuApi,
                    topBarUrl,
                    enumUrl,
                    showHeader
                });
                const filtered = (app?.menuItems ?? []).filter(
                    (item) => !['-1', '-2'].includes(item.menuId)
                )
                const BxAppNavigations = filtered.reduce((acc, item) => {
                    if ((item.subMenus?.length ?? 0) > 0) {
                        return acc.concat(item.subMenus);
                    } else {
                        return acc.concat([item]);
                    }
                }, []);


                if (BxAppNavigations.length <= 1) {
                    isInBxApp && window.BXBridge?.hideNavigationBar()
                } else {
                    isInBxApp && window.BXBridge?.showNavigationBar(JSON.stringify(BxAppNavigations))
                }

            } else app = appModel;
            this.setState({
                render: true,
                app: {
                    ...app,
                    functionItems: app?.functionItems?.map(e => {
                        return {
                            ...e,
                            functionId: e.functionId + e.url,
                            subFunctionItems: e.subFunctionItems?.map(e => {
                                return {
                                    ...e,
                                    functionId: e.functionId + e.url
                                }
                            })
                        }
                    })
                }
            }, () => {
                EventBus.emit('reloadAppInfoOk', true);
            });
        } catch (e) {
            this.setState({
                render: true
            })
        }
    }
    onOpenChange = (openKeys) => {
        this.setState({
            ...this.state,
            defaultOpenKeys: openKeys,
        });
    };
    getMenu = (functionItems: FunctionItem[]): JSX.Element[] => {
        let list: Array<JSX.Element> = [];
        list =
            functionItems &&
            functionItems.length &&
            functionItems.map((functionItem: FunctionItem, index: number) =>
                    functionItem.subFunctionItems &&
                    functionItem.subFunctionItems.length ? (
                        <SubMenu
                            key={functionItem.functionId}
                            title={
                                <span style={{display: "flex"}}>
                <img
                    width="26"
                    height="48"
                    src={functionItem.icon}
                    style={{display: "flex", paddingRight: 8}}
                    alt={''}/>
                <span>{functionItem.name}</span>
              </span>
                            }
                        >
                            {this.getMenu(functionItem.subFunctionItems)}
                        </SubMenu>
                    ) : (
                        <Menu.Item key={functionItem.url}>
            <span style={{display: "flex"}}>
              {functionItem.icon && (
                  <img
                      width="26"
                      height="48"
                      src={functionItem.icon}
                      style={{display: "flex", paddingRight: 8}}
                      alt={''}/>
              )}
                <span>{functionItem.name}</span>
            </span>
                        </Menu.Item>
                    )
            );
        return list;
    };
    findPathByKey = (key: string): string[] => {
        for (let item of this.state.app.functionItems) {
            if (item.url === key) {
                return [item.name];
            } else if (item.subFunctionItems && item.subFunctionItems.length) {
                for (let subItem of item.subFunctionItems) {
                    if (subItem.url === key) {
                        return [item.name, subItem.name];
                    }
                }
            }
        }
        return [];
    };
    goto = ({key}) => {
        this.isInternalNavigation = true; // **标记为内部跳转**
        this.props.onMenuClick && this.props.onMenuClick();
        this.setState({selectedKeys: [key]});
        let paths = this.findPathByKey(key);
        let {breadcrumbItem} = this.state;
        this.setState({breadcrumbItem: [breadcrumbItem[0], ...paths]});
        EventBus.emit("on-menuitem-click");
        if (this.props.location.pathname !== key) {
            this.props.history.push({pathname: key});
        }

    };
    showMenu = () => {
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    render() {
        let {
            children,
            appName,
            hiddenLeftMenu: hiddenLeftMenu1 = false,
            showHeader: showHeader1 = true,
            breadCrumb = true,
            defaultUrl,
            defaultDes
        } = this.props;
        let {app, breadcrumbItem, render, selectedKeys, defaultOpenKeys, showMenu, initialized} = this.state;
        const hiddenLeftMenu = isInBxApp ? true : hiddenLeftMenu1;
        const showHeader = isInBxApp ? false : showHeader1;
        return (
            render && <Layout style={{minHeight: "100vh"}}>
                {showHeader && (
                    <UIHeader
                        menuItems={app.menuItems}
                        avatar={app.user.avatar}
                        userName={app.user.username}
                        fullName={app.user.fullName}
                        name={app.tenant.appName}
                        schoolName={app.tenant.name}
                        appName={appName}
                        logo={app.tenant.logo}
                        // mode="light"
                        hasSearchBar={app.hasSearchBar}
                        showBackToOther={app.user.showBackToOther}
                        hiddenLogout={app.user.hiddenLogout}
                    />
                )}
                {isInBxApp && (<div className="show-menu-btn" onClick={this.showMenu}>
                    <img className="img" src={showMemu}/>
                    <div className="title">菜单</div>
                </div>)}
                {app?.functionItems &&
                app?.functionItems.length ? <Layout style={{marginTop: showHeader ? 48 : 0}}>
                    {(!hiddenLeftMenu || showMenu) && (
                        <>
                            <Sider
                                width={180}
                                className={showMenu ? "site-layout-background-fixed" : "site-layout-background"}
                                style={{
                                    overflowX: "hidden",
                                    overflowY: "auto",
                                    height: showHeader ? "calc(100vh - 48px)" : "100vh",
                                    position: "fixed",
                                    left: 0,
                                }}
                            >
                                {isInBxApp && (<div className="hiddenMenu" onClick={this.showMenu}>
                                    <div className="title">菜单</div>
                                    <img className="img" src={hiddenMenu}/>
                                </div>)}
                                <Menu
                                    inlineIndent={15}
                                    onClick={(e) => this.goto(e)}
                                    onOpenChange={this.onOpenChange}
                                    mode="inline"
                                    openKeys={defaultOpenKeys}
                                    selectedKeys={selectedKeys}
                                    style={{height: isInBxApp ? "calc(100% - 48px)" : "100%"}}
                                    className="main-ant-menu"
                                >
                                    {this.getMenu(this.state.app.functionItems || [])}
                                </Menu>
                            </Sider>
                            {isInBxApp && showMenu && (
                                <div className="showMenuMask" onClick={this.showMenu}></div>)}
                        </>
                    )}
                    <Layout
                        style={{
                            padding: breadCrumb ? `0 ${hiddenLeftMenu ? "0" : "24px"} 0 ${hiddenLeftMenu ? "0" : "16px"}` : hiddenLeftMenu ? "0px" : "0px 0px 0px 16px",
                            marginLeft: hiddenLeftMenu ? 0 : 180,
                            backgroundColor: "#F0F2F5",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                        }}
                        className="main"
                    >
                        {breadCrumb && <Breadcrumb
                            style={{
                                padding: "17px 0 8px",
                                width: "100%",
                                backgroundColor: "#f0f2f5",
                                fontSize: "14px",
                            }}
                        >
                            {breadcrumbItem.map((item, index) => (
                                <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
                            ))}
                        </Breadcrumb>}
                        <div className="right-top-label"></div>
                        <Content
                            id={'galaxy-component-framework'}
                            style={{
                                margin: breadCrumb ? "0 0 16px" : "0px",
                                marginTop: 0,
                                minHeight: 280,
                                backgroundColor: "#fff",
                            }}
                        >
                            {initialized && <AppContext.Provider
                                value={{
                                    zoneList: this.state.zoneList,
                                    enumData: this.state.app.enumData,
                                }}
                            >
                                {children}
                            </AppContext.Provider>}
                        </Content>
                    </Layout>
                </Layout> : <Layout style={{marginTop: showHeader ? 48 : 0}}>
                    <div className={'galaxy-no-menu-container'}>
                        <div className={'galaxy-no-menu-content'}>
                            <img style={{
                                width: 256,
                                height: 256
                            }}
                                 src={defaultUrl || 'https://bs-application-resource.oss-cn-beijing.aliyuncs.com/pc/icon/portal2/no-menu.svg'}
                                 alt={defaultDes}/>
                            <span>{defaultDes || '抱歉，该功能暂未开放'}</span>
                        </div>
                    </div>
                </Layout>}

            </Layout>
        );
    }
}
